/**
 * Stock Report Hooks
 * @see Sprint 16 - Rapport de Stock
 * @see US-16.5 - UI Rapport Principal
 */

import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { getStockReport, getStockReportKPIs } from '../services/stock-report.service';
import type { StockReportQueryParams } from '@bstock/shared';

/**
 * Query key factory for stock report
 */
export const stockReportKeys = {
  all: ['stock-report'] as const,
  report: (params: StockReportQueryParams) =>
    [...stockReportKeys.all, 'report', params] as const,
  kpis: (params: StockReportQueryParams) =>
    [...stockReportKeys.all, 'kpis', params] as const,
};

/**
 * Hook to get stock report
 */
export function useStockReport(params: StockReportQueryParams | null) {
  return useQuery({
    queryKey: stockReportKeys.report(params!),
    queryFn: () => getStockReport(params!),
    enabled: !!params && !!params.dateFrom && !!params.dateTo,
    placeholderData: keepPreviousData,
    staleTime: 60_000, // 1 minute
  });
}

/**
 * Hook to get stock report KPIs
 */
export function useStockReportKPIs(params: StockReportQueryParams | null) {
  return useQuery({
    queryKey: stockReportKeys.kpis(params!),
    queryFn: () => getStockReportKPIs(params!),
    enabled: !!params && !!params.dateFrom && !!params.dateTo,
    staleTime: 60_000, // 1 minute
  });
}
